export default __webpack_public_path__ + "static/Raising-9628fbbd48c7c88f30ed81875c0a95e0.jpg";